import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "./utils";

export function Modal({ children, show, onClose, ...props }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div
            className={cn(
              "relative bg-white rounded-lg p-6 w-11/12 md:w-1/2 lg:w-1/3",
              props.className
            )}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-sm px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
            >
              Close
            </button>
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
